<script setup lang="ts">
/**
 * Каркас экрана: сайдбар 240px и колонка контента. Тулбар рисует сам экран —
 * в макете у него десять контекстов, и общий на всех оказался бы набором
 * условий вместо разметки.
 */
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import TrackerSidebar from '@/components/TrackerSidebar.vue'
import { useAuthStore } from '@/features/auth/store'

const COLLAPSED_KEY = 'tracker-sidebar-collapsed'

const router = useRouter()

const auth = useAuthStore()

const collapsed = ref(localStorage.getItem(COLLAPSED_KEY) === '1')

const user = computed(() =>
  auth.user ? { name: auth.user.name || auth.user.email, role: auth.user.roles[0] } : null,
)

const logout = async () => {
  await auth.logout()
  await router.push({ name: 'login' })
}

const toggleCollapsed = () => {
  collapsed.value = !collapsed.value
  localStorage.setItem(COLLAPSED_KEY, collapsed.value ? '1' : '0')
}
</script>

<template>
  <div class="layout">
    <TrackerSidebar
      :collapsed="collapsed"
      :user="user"
      @toggle-collapse="toggleCollapsed"
      @user-menu="logout"
    />

    <main class="layout__main">
      <RouterView />
    </main>
  </div>
</template>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
  background-color: var(--color-bg-app);
}

.layout__main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
</style>
